import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Building the Future with
            <span className="hero-gradient"> Intelligent AI Solutions</span>
          </h1>
          <p className="hero-description">
            We're a fresh AI consultancy ready to transform your business with cutting-edge AI applications 
            and autonomous agent systems. From strategic planning to full-scale implementation, we bring 
            innovation, expertise, and dedication to deliver AI solutions that create real-world impact.
          </p>
          <div className="hero-cta">
            <button onClick={scrollToContact} className="btn btn-primary">
              Start Your AI Journey
            </button>
            <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="btn btn-secondary">
              Explore Our Services
            </button>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">10+</div>
              <div className="stat-label">AI Technologies</div>
            </div>
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Focused</div>
            </div>
            <div className="stat">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-bg-gradient"></div>
    </section>
  );
};

export default Hero;

